import { render, staticRenderFns } from "./ShareLinkButton.vue?vue&type=template&id=677a5c40&scoped=true&"
import script from "./ShareLinkButton.vue?vue&type=script&lang=js&"
export * from "./ShareLinkButton.vue?vue&type=script&lang=js&"
import style0 from "./ShareLinkButton.vue?vue&type=style&index=0&id=677a5c40&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "677a5c40",
  null
  
)

export default component.exports